(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeDialogController', StatementTypeDialogController);

    StatementTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StatementType'];

    function StatementTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StatementType) {
        var vm = this;

        vm.statementType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statementType.id !== null) {
                StatementType.update(vm.statementType, onSaveSuccess, onSaveError);
            } else {
                StatementType.save(vm.statementType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:statementTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
